import React from 'react';

import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import crownImg from '@pkg/assets/images/crown.png';
import { Modal } from '@pkg/components/Modal';
import { useMedia } from '@pkg/hooks';

import { CancelText, ContentWrapper, CrownImage, CTAButton, Heading, HeadingWrapper, SubHeading } from './styles';

interface Props {
    onClose(): void;
    isOpen: boolean;
}

export const FreeYatModal = ({ onClose, isOpen }: Props) => {
    const { t } = useTranslation(['dashboard']);
    const theme = useTheme();
    const notMobile = useMedia(`(min-width: ${theme.breakpoints.mobile})`);
    const navigate = useNavigate();
    const handleNavigate = () => {
        navigate('/create', { state: { enableGoBack: true } });
    };

    const contentMarkup = (
        <>
            <HeadingWrapper>
                <CrownImage src={crownImg} alt="Crown emoji" />
                <Heading>
                    {notMobile ? t('free_yat_modal_heading_desktop') : t('free_yat_modal_heading_mobile')}
                </Heading>
                <SubHeading>{t('free_yat_modal_subheading_first')}</SubHeading>
                <SubHeading>{t('free_yat_modal_subheading_second')}</SubHeading>
            </HeadingWrapper>
            <ContentWrapper>
                <CTAButton onClick={handleNavigate} size={'large'}>
                    {notMobile ? t('free_yat_modal_cta_desktop') : t('free_yat_modal_cta_mobile')}
                </CTAButton>
                <CancelText onClick={onClose}>{t('free_yat_modal_cancel_text')}</CancelText>
            </ContentWrapper>
        </>
    );

    return (
        <AnimatePresence mode="wait">
            {isOpen && (
                <Modal fullScreenMobile={false} onClose={onClose}>
                    {contentMarkup}
                </Modal>
            )}
        </AnimatePresence>
    );
};
